import * as types from './actionTypes';
import {beginAjaxCall, ajaxCallError} from './ajaxStatusActions';
import taskApi from '../api/taskApi';


function store(task) {
    return function (dispatch) {
        return taskApi.store(task).then(response => {
            dispatch(storeTaskSuccess(response));
            return Promise.resolve(response);
        }, (response) => {
            dispatch(storeTaskFailure(response.errors));
            return Promise.reject(response.errors);
        });
    };
}

function storeTaskSuccess(task) {
    return {type: types.STORE_TASK_SUCCESS, task};
}

function storeTaskFailure(errors) {
    return {type: types.STORE_TASK_FAILURE, errors: errors};
}

function update(task) {
    return function (dispatch) {
        return taskApi.update(task).then(response => {
            dispatch(updateTaskSuccess(response));
            return Promise.resolve(response);
        }, (response) => {
            dispatch(updateTaskFailure(response.errors));
            return Promise.reject(response.errors);
        });
        /*return taskApi.update(task).then(response => {
            if (!response.error) {
                dispatch(updateTaskSuccess(response));
            } else {
                dispatch(updateTaskFailure({error: response.error}));
            }
        }).catch((error) => {
            dispatch(updateTaskFailure({error: error.text}));
        });*/
    };
}

function updateTaskSuccess(task) {
    return {type: types.UPDATE_TASK_SUCCESS, task};
}

function updateTaskFailure(response) {
    return {type: types.UPDATE_TASK_FAILURE, errors: response.errors};
}

function getMyTasks(date) {
    return function (dispatch) {
        return taskApi.getMyTasks(date).then(tasks => {
            dispatch(getMyTasksSuccess(tasks));
        }).catch(error => {
            throw(error);
        });
    };
}

function getMyTasksSuccess(tasks) {
    return {type: types.GET_MY_TASKS_SUCCESS, tasks};
}

function deleteTask(task) {
    return function (dispatch) {
        return taskApi.delete(task).then(task => {
            dispatch(deleteTaskSuccess(task));
        }).catch(error => {
            //throw(error);
        });
    };
}

function deleteTaskSuccess(task) {
    return {type: types.DELETE_TASK_SUCCESS, task};
}

export {
    store,
    update,
    getMyTasks,
    deleteTask
};


/** WEBPACK FOOTER **
 ** ./src/actions/taskActions.js
 **/